export default "__VITE_ASSET__DPDmTRFW__"